import * as React from 'react'

const SkipNav: React.FC = () => {
    return (
        <>
            <a href="#content" className="skip-nav">
                메인 컨텐츠로 건너띄기
            </a>
        </>
    )
}

export default SkipNav
